export function removeZeroDecimals(value) {
    const num = Number(value); // convert string to number
    return Number.isInteger(num) ? num.toString() : num.toFixed(2);
}